<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <h4 v-html="title"></h4>
        <form v-on:submit.prevent="close(true, field)">
          <div class="fieldGroup">
            <input type="text" class="field" :placeholder="placeholder"
              v-if="type === 'input'" v-model="field">
            <textarea class="field" :placeholder="placeholder"
              v-else v-model="field"></textarea>
          </div>
          <div class="modalAction">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit">
              <span v-if="action">{{action}}</span>
              <span v-else>Insert</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      field: '',
      title: '',
      placeholder: '',
      action: '',
      type: 'input',
      next: null,
    };
  },
  methods: {
    open(d, n) {
      this.title = d.title;
      this.placeholder = d.placeholder;
      this.action = d.action;
      this.type = d.type || 'input';
      this.field = d.model || '';
      this.next = n;
      this.show = true;
    },
    close(b, val) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, val);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.5);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      max-width: none;
      width: 440px;
      @media (max-width: 680px) {
        width: auto;
        left: 10px; right: 10px;
        padding: 30px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .hint{
        color: #767676;
        font-size: 14px;
        margin-top: 6px;
        video{
          width: 100%;
          border-radius: 5px;
          margin-top: 10px;
        }
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 30px;
        text-align: right;
        border-top: #eee 1px solid;
        @media (max-width: 680px) {
          margin: 30px -30px -30px;
        }
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
